import script from "./mechanism.vue?vue&type=script&setup=true&lang=ts"
export * from "./mechanism.vue?vue&type=script&setup=true&lang=ts"

import "./mechanism.vue?vue&type=style&index=0&id=3017eef5&scoped=true&lang=less"
import "./mechanism.vue?vue&type=style&index=1&id=3017eef5&scoped=true&lang=less"

import exportComponent from "/Users/jizhengliang/Desktop/octopus/edu/educms-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3017eef5"]])

export default __exports__